import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "menu"];

  connect() {
    this.menu = this.menuTarget;
    document.body.appendChild(this.menu);
  }

  disconnect() {
    this.element.appendChild(this.menu);
  }

  toggle(event) {
    event.stopPropagation();
    this.menu.hidden ? this.open() : this.hide();
  }

  open() {
    const rect = this.buttonTarget.getBoundingClientRect();
    this.menu.style.top = `${rect.bottom + 4}px`;
    this.menu.style.right = `${window.innerWidth - rect.right}px`;
    this.menu.hidden = false;
    window.addEventListener("scroll", () => this.hide(), {
      once: true,
      passive: true,
      capture: true
    });
  }

  hide() {
    this.menu.hidden = true;
  }

  hideOnClickOutside(event) {
    if (
      !this.element.contains(event.target) &&
      !this.menu.contains(event.target)
    ) {
      this.hide();
    }
  }
}
